module.exports = __webpack_public_path__ + "static/media/FORMATO CERTIFICADO DE MATERIAS DICTADAS.21ccb280.pdf";